import { useEffect, useState } from "react";
import { IAlert } from "../interface/IAlert";
import { getWebNotificationRoute } from "@api-routes";
import { getResponseToState, IAlertListResponse } from "../mappers/getAlertListMapper";
import { useFetch } from "@common/hook/useFetch";
import { getLanguage } from "@utils/changeLanguage";

export const useAlertList = () => {
    const [alertList, setAlertList] = useState<IAlert[]>([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [getAlertListState, { get }] = useFetch();
    const lang = getLanguage();

    const getAlertList = () =>
        get<IAlertListResponse>(getWebNotificationRoute(currentPage, lang)).then((alertListResponse) => {
            if (alertListResponse?.webNotifications) {
                const alertListMapped = getResponseToState(alertListResponse);

                setAlertList(alertListMapped.content);
                setTotalPages(alertListMapped.totalPages);
            }
        });

    useEffect(() => {
        getAlertList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);

    return { alertList, getAlertListState, getAlertList, currentPage, setCurrentPage, totalPages };
};
